"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CloseButton = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _Button = require("../../Button");

var _theme = require("../../../theme");

const CloseButton = (0, _styledComponents.default)(_Button.Button).attrs({
  size: 'extra-small',
  variant: 'transparent',
  color: 'base',
  shape: 'square'
}).withConfig({
  displayName: "ToastCloseButtonstyles__CloseButton"
})(["flex-shrink:0;margin:", " ", " ", " auto;"], (0, _theme.rem)(-2), (0, _theme.rem)(-2), (0, _theme.rem)(-2));
exports.CloseButton = CloseButton;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJuYW1lcyI6WyJDbG9zZUJ1dHRvbiIsInN0eWxlZCIsIkJ1dHRvbiIsImF0dHJzIiwic2l6ZSIsInZhcmlhbnQiLCJjb2xvciIsInNoYXBlIiwicmVtIl0sInNvdXJjZXMiOlsiLi4vLi4vLi4vLi4vc3JjL2NvbXBvbmVudHMvVG9hc3QvVG9hc3RDbG9zZUJ1dHRvbi9Ub2FzdENsb3NlQnV0dG9uLnN0eWxlcy50cyJdLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgc3R5bGVkIGZyb20gJ3N0eWxlZC1jb21wb25lbnRzJ1xuaW1wb3J0IHsgQnV0dG9uIH0gZnJvbSAnfmNvbXBvbmVudHMvQnV0dG9uJ1xuaW1wb3J0IHsgcmVtIH0gZnJvbSAnfnRoZW1lJ1xuXG5leHBvcnQgY29uc3QgQ2xvc2VCdXR0b24gPSBzdHlsZWQoQnV0dG9uKS5hdHRycyh7XG4gIHNpemU6ICdleHRyYS1zbWFsbCcsXG4gIHZhcmlhbnQ6ICd0cmFuc3BhcmVudCcsXG4gIGNvbG9yOiAnYmFzZScsXG4gIHNoYXBlOiAnc3F1YXJlJyxcbn0pYFxuICBmbGV4LXNocmluazogMDtcbiAgbWFyZ2luOiAke3JlbSgtMil9ICR7cmVtKC0yKX0gJHtyZW0oLTIpfSBhdXRvO1xuYFxuIl0sIm1hcHBpbmdzIjoiOzs7Ozs7Ozs7QUFBQTs7QUFDQTs7QUFDQTs7QUFFTyxNQUFNQSxXQUFXLEdBQUcsSUFBQUMseUJBQUEsRUFBT0MsY0FBUCxFQUFlQyxLQUFmLENBQXFCO0VBQzlDQyxJQUFJLEVBQUUsYUFEd0M7RUFFOUNDLE9BQU8sRUFBRSxhQUZxQztFQUc5Q0MsS0FBSyxFQUFFLE1BSHVDO0VBSTlDQyxLQUFLLEVBQUU7QUFKdUMsQ0FBckIsQ0FBSDtFQUFBO0FBQUEsa0RBT1osSUFBQUMsVUFBQSxFQUFJLENBQUMsQ0FBTCxDQVBZLEVBT0QsSUFBQUEsVUFBQSxFQUFJLENBQUMsQ0FBTCxDQVBDLEVBT1UsSUFBQUEsVUFBQSxFQUFJLENBQUMsQ0FBTCxDQVBWLENBQWpCIn0=